export * from "./NumberInput.settings";
